import { setErrorDialog, getheader, serverUrl, postMethodByCallBack, getMethodByCallBack, cacheTypes } from "../../../store/api/CommonFunctions";



export function GetAllProduct() {
  return dispatch => {
    fetch(serverUrl + "ReceptionTasksAPI/GetProductNames/")
      .then(res => res.json())
      .then(res => {
        //console.log(res);
        return dispatch({
          type: "FETCH_DATA_PRODUCT",
          data: res
        })
      }
      ).catch(err => console.error('[FETCH_DATA_PRODUCT]', err));
  };
}
export function getProductInfoBySerialOrCode(data, onProductFound) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    })
    fetch(serverUrl + "api/ProductAPI/GetProductBySerialOrBarCode?serialAndBarCode=" + data, {
      headers: getheader()
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (!res.ID) {
          if (res === "ProductNotFount") {
            alert("کالایی با این مشخصات وجود ندارد");
            return;
          }
          else {
            alert("اشکال در انجام عملیات");
            console.log("[FETCH_PRODUCT_BY_QRCODE]", res);
            return;
          }
        }
        onProductFound(res);
        // dispatch({
        //   type: "FETCH_PRODUCT_BY_QRCODE",
        //   data: res
        // })
      }).catch(e => console.log("[FETCH_PRODUCT_BY_QRCODE]", e));
  }
}
export function getProductBySerialOrGuaranteeCard(data) {
  if (!data || data === '') {
    alert("مقداری برای جستجو وجود ندارد");
    return;
  }
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    });
    fetch(serverUrl + "api/ProductAPI/GetProductBySerialOrGuaranteeCard?serialOrCardNo=" + data, {
      headers: getheader()
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (!res.ID) {
          if (res === "ProductNotFound") {
            alert("کالایی با این مشخصات وجود ندارد");
            return;
          }
          else {
            alert("اشکال در انجام عملیات");
            console.log("[FETCH_PRODUCT_BY_QRCODE]", res);
            return;
          }
        }
        dispatch({
          type: "FETCH_PRODUCT_BY_QRCODE",
          data: res
        })
      }).catch(e => console.log("[FETCH_PRODUCT_BY_QRCODE]", e));
  }
}

export function setQrPopupStatus(status) {
  return dispatch => {
    return dispatch({
      type: "SET_QRPOPUP_STATUS",
      data: status
    });
  }
}
export function setProductPopup(status) {
  return dispatch => {
    return dispatch({
      type: "SET_PRODUCT_POPUP",
      data: status
    });
  }
}
export function setImagePopup(status) {
  return dispatch => {
    dispatch({
      type: "SET_IMAGE_POPUP",
      data: status
    });
  }
}
export function setDialog(status) {
  return dispatch => {
    return dispatch({
      type: "SET_DIALOG",
      data: status
    });
  }
}
export function searchProductForSelect(data) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    })

    fetch(serverUrl + `api/ProductAPI/SearchProductForSelect`, {
      headers: {
        'Token': localStorage.getItem("token"),
        'Content-Type': 'application/json',
        'Data-Type': 'json'
      },
      method: "POST",
      body: JSON.stringify(data)
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (!res.ID) {
          if (res === "ProductNotFount") {
            alert("کالایی با این مشخصات وجود ندارد");
            res = [];
          }
          if (res === "FillSearchFields") {
            alert("کادرهای جستجو پر نشده است");
            res = [];
          }
          else if (res.Message === "Error") {
            alert("اشکال در انجام عملیات");
            console.log("[SEARCH_PRODUCT_SELECT]", res);
            res = []
          }
        }
        dispatch({
          type: "SEARCH_PRODUCT_SELECT",
          data: res
        })
      }).catch(e => {
        dispatch({
          type: "SEARCH_PRODUCT_SELECT",
          data: []
        });
        console.log("[SEARCH_PRODUCT_SELECT]", e)
      });
  }
}
export function searchProducts4Invoice(data, invoiceType) {
  return dispatch => {
    dispatch({
      type: "LOADING",
      data: true
    })
    fetch(serverUrl + `api/ProductAPI/SearchProducts4Invoice?invoiceType=${invoiceType}`, {
      headers: {
        'Token': localStorage.getItem("token"),
        'Content-Type': 'application/json',
        'Data-Type': 'json'

      },
      method: "POST",
      body: JSON.stringify(data)
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (!res.ID) {
          if (res === "ProductNotFount") {
            alert("کالایی با این مشخصات وجود ندارد");
            return;
          }
          else if (res.Message === "Error") {
            alert("اشکال در انجام عملیات");
            console.log("[SEARCH_PURCHACE_PRODUCTS]", res);
            return;
          }
        }
        dispatch({
          type: "SEARCH_PURCHACE_PRODUCTS",
          data: res
        })
      }).catch(e => console.log("[SEARCH_PURCHACE_PRODUCTS]", e));
  }
}
export function searchProducts(data) {
  return dispatch => {
    dispatch({
      type: "SEARCH_PRODUCTS_Full",
      data: "PENDING"
    });
    dispatch({
      type: "PRODUCT_SEARCH_FILTERS",
      data: data
    });
    fetch(serverUrl + `api/ProductAPI/SearchProducts`, {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data)
    })
      .then(res => res.json())
      .then(res => {
        dispatch({
          type: "LOADING",
          data: false
        })
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "جستجوی کالاها");
          res = null;
        }
        dispatch({
          type: "SEARCH_PRODUCTS_Full",
          data: res
        });
      }).catch(e => console.log("[SEARCH_PRODUCTS_Full]", e));
  }
}
export function getProductInfoFromModal(res) {
  return dispatch => dispatch({
    type: "PRODUCT_INFO_FROM_MODAL",
    data: res
  })
}
export function resetProductQRCode() {
  return dispatch => {
    return dispatch({
      type: "FETCH_PRODUCT_BY_QRCODE",
      data: ""

    });
  }
}
export function setProductBugPop(status) {
  return dispatch => {
    return dispatch({
      type: "SET_PBUG_POP",
      data: status
    });
  }
}
export function searchProductBug(data) {
  return dispatch => {
    dispatch({
      type: "SEARCH_PRODUCT_BUG",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ProductBugAPI/SearchProductBug", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res === "Error" || (res.Message && (res.Message.search("error") || res.Message === "Error"))) {
          alert("اشکال در بازیابی لیست ایرادات");
          res = null;
        }
        return dispatch({
          type: "SEARCH_PRODUCT_BUG",
          data: res
        });
      }).catch(e => {
        alert("اشکال در بازیابی لیست ایرادات");
        console.log("[SEARCH_PRODUCT_BUG]", e);
        return dispatch({
          type: "SEARCH_PRODUCT_BUG",
          data: null
        });
      })
  }
}
export function setAccessoriesPop(status) {
  return dispatch => {
    return dispatch({
      type: "SET_ACCESSORIES_POP",
      data: status
    });
  }
}
export function loadProductAccessories(data) {
  return dispatch => {
    dispatch({
      type: "LOAD_PRODUCT_ACCESSORIES",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ProductAPI/LoadProductAccessories", {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data),
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res === "Error" || res.Message) {
          alert("بازیابی لیست لوازم همراه با مشکل مواجه شد");
          res = null;
        }
        return dispatch({
          type: "LOAD_PRODUCT_ACCESSORIES",
          data: res
        });
      }).catch(e => {
        console.log("[LOAD_PRODUCT_ACCESSORIES]", e);
        return dispatch({
          type: "LOAD_PRODUCT_ACCESSORIES",
          data: null
        });
      })
  }
}
export function getAllProductMainGroups() {
  return dispatch => {
    dispatch({
      type: "GET_PRODUCT_MAIN_GROUPS",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ProductGroupingAPI/GetAllProductMainGroups", {
      headers: getheader(),
      method: "GET"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "دریافت گروههای اصلی کالا");
          res = null;
        }
        dispatch({
          type: "GET_PRODUCT_MAIN_GROUPS",
          data: res
        });
      }).catch(e => {
        dispatch({
          type: "GET_PRODUCT_MAIN_GROUPS",
          data: null
        });
      })
  }
}
export function getProductGroups(mainGroupID) {
  return dispatch => {
    if (!mainGroupID) {
      return dispatch({
        type: "GET_PRODUCT_GROUPS",
        data: []
      });
    }
    dispatch({
      type: "GET_PRODUCT_GROUPS",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ProductGroupingAPI/GetProductGroups?MainGroupID=" + mainGroupID, {
      headers: getheader(),
      method: "GET"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "دریافت گروههای فرعی کالا");
          res = null;
        }
        dispatch({
          type: "GET_PRODUCT_GROUPS",
          data: res
        });
      }).catch(e => {
        dispatch({
          type: "GET_PRODUCT_GROUPS",
          data: null
        });
      })
  }
}
export function addEditProductMainGroup(data, fn) {
  return dispatch => {
    fetch(serverUrl + "api/ProductGroupingAPI/AddOrUpdateMainGroup", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST"
    }).then(res => res.json())
      .then(res => {
        setErrorDialog(dispatch, res.Message, "افزودن گروه اصلی کالا");
        if (res.Result) {
          dispatch({
            type: "GET_PRODUCT_MAIN_GROUPS",
            data: res.Data
          });
          if (fn)
            fn();
        }
      }).catch(e => {
        console.log("[AddProductMainGroup]", e);
      })
  }
}
export function addEditProductGroup(data, fn) {

  return dispatch => {
    if (!data.MainGroupID || Number(data.MainGroupID) === 0) {
      setErrorDialog(dispatch, "ابتدا گروه اصلی را انتخاب کنید", "افزودن گروه فرعی کالا");
      return;
    }
    fetch(serverUrl + "api/ProductGroupingAPI/AddOrUpdateProductGroup", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST"
    }).then(res => res.json())
      .then(res => {
        setErrorDialog(dispatch, res.Message, "افزودن گروه فرعی کالا");
        if (res.Result) {
          dispatch({
            type: "GET_PRODUCT_GROUPS",
            data: res.Data
          });
          if (fn)
            fn();
        }
      }).catch(e => {
        console.log("[AddProductMainGroup]", e);
      })
  }
}
export function deleteProductGroup(id, fn) {

  return dispatch => {

    fetch(serverUrl + "api/ProductGroupingAPI/DeleteProductGroup", {
      headers: getheader(),
      body: JSON.stringify(id),
      method: "POST"
    }).then(res => res.json())
      .then(res => {
        setErrorDialog(dispatch, res.Message, "حذف گروه فرعی کالا");
        if (res.Result) {
          dispatch({
            type: "GET_PRODUCT_GROUPS",
            data: res.Data
          });
          if (fn)
            fn();
        }
      }).catch(e => {
        console.log("[AddProductMainGroup]", e);
      })
  }
}
export function deleteProductMainGroup(id, fn) {

  return dispatch => {

    fetch(serverUrl + "api/ProductGroupingAPI/DeleteMainGroup", {
      headers: getheader(),
      body: JSON.stringify(id),
      method: "POST"
    }).then(res => res.json())
      .then(res => {
        setErrorDialog(dispatch, res.Message, "حذف گروه اصلی کالا");
        if (res.Result) {
          dispatch({
            type: "GET_PRODUCT_MAIN_GROUPS",
            data: res.Data
          });
          if (fn)
            fn();
        }
      }).catch(e => {
        console.log("[AddProductMainGroup]", e);
      })
  }
}
export function addOrUpdateProduct(data, fn) {
  return dispatch => {
    fetch(serverUrl + "api/ProductAPI/AddOrUpdateProduct", {
      headers: getheader(),
      method: "POST",
      body: JSON.stringify(data)
    }).then(res => res.json())
      .then(res => {
        setErrorDialog(dispatch, res.Message, "ثبت اطلاعات کالا");
        if (res.Data) {
          dispatch({
            type: "GET_PRODUCT",
            data: data
          });
        }
        if (res.Data && fn) {
          fn(res.Data);
        }
      })
  }
}
export function getAllProductHolders(type) {
  return dispatch => {
    dispatch({
      type: "GET_PRODUCT_HOLDERS",
      data: "PENDING"
    });
    fetch(serverUrl + "api/GuarantyHolderAPI/GetAllProductHolder", {
      headers: getheader(),
      method: "POST",
      body: type
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          res = null;
        }
        dispatch({
          type: "GET_PRODUCT_HOLDERS",
          data: res
        })
      })
  }
}
export function getLastCode(setCode) {
  getMethodByCallBack("api/ProductAPI/GetLastCode", cacheTypes.NoCache, setCode, "GetLastCode");
}
export function getCostCenterList(name) {
  return dispatch => {
    dispatch({
      type: "GET_COSTCENTER_LIST",
      data: "PENDING"
    });
    fetch(serverUrl + "api/DocumentsAPI/GetCostCenterList?centerName=" + name ?? '', {
      headers: getheader(),
      method: "GET"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          res = null;
        }
        dispatch({
          type: "GET_COSTCENTER_LIST",
          data: res
        });
      }).catch(e => console.log("[GET_LAST_PRODUCT_CODE]", e));
  }
}
export function getProduct(id, fn) {
  return dispatch => {
    dispatch({
      type: "GET_PRODUCT",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ProductAPI/GetProductByID?id=" + id, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "دریافت اطلاعات کالا");
          res = null;
        }
        if (fn) {
          fn(res);
        }
        dispatch({
          type: "GET_PRODUCT",
          data: res
        });

      }).catch(e => console.log(e));

  }
}
export function getProductByCallback(id, onGet) {
  getMethodByCallBack(`api/ProductAPI/GetProductByID?id=${id}`, cacheTypes.NoCache, onGet, "GetProductByID");
}
export function getProductGroups4Select(name) {
  return dispatch => {
    dispatch({
      type: "GET_PRODUCTGROUP_For_SELECT",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ProductAPI/GetProductGroups4Select?name=" + name ?? '', {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          res = null;
        }
        dispatch({
          type: "GET_PRODUCTGROUP_For_SELECT",
          data: res
        });
      }).catch(e => {
        console.log("[GET_PRODUCTGROUP_For_SELECT]", e);
      })
  }
}
export function addProductGrouping(data, fn) {
  return dispatch => {
    fetch(serverUrl + "api/ProductAPI/AddProductGrouping", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "افزودن گروهبندی کالا");
          return;
        }
        setErrorDialog(dispatch, "success", "افزودن گروهبندی کالا");
        if (fn) {
          fn(res);
        }
      }).catch(e => console.log("[ADD_PRODUCT_GROUPING]", e));
  }
}
export function editProductGrouping(data, fn) {
  return dispatch => {
    fetch(serverUrl + "api/ProductAPI/EditProductGrouping", {
      headers: getheader(),
      body: JSON.stringify(data),
      method: "POST"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "ویرایش گروهبندی کالا");
          return;
        }
        setErrorDialog(dispatch, "success", "ویرایش گروهبندی کالا");
        if (fn) {
          fn(res);
        }
      }).catch(e => console.log("[EDIT_PRODUCT_GROUPING]", e));
  }
}

export function deleteGrouping(productID, groupID, fn) {
  return dispatch => {
    fetch(serverUrl + `api/ProductAPI/DeleteGrouping?productID=${productID}&groupID=${groupID}`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          setErrorDialog(dispatch, res.Message, "حذف گروهبندی کالا");
          return;
        }
        setErrorDialog(dispatch, "success", "حذف گروهبندی کالا");
        if (fn) {
          fn();
        }
      }).catch(e => console.log(e));
  }
}
export function getProductAttachments(productID) {
  return dispatch => {
    dispatch({
      type: "GET_PRODUCT_ATTACHMENTS",
      data: "PENDING"
    });
    fetch(serverUrl + `api/Attachments/GetAttachmentList?parentID=${productID}&attachmentType=ProductAttachment`, {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(
        res => {
          if (res.Message) {
            setErrorDialog(dispatch, res.Message, "دریافت پیوست های کالا");
            res = null;
          }
          dispatch({
            type: "GET_PRODUCT_ATTACHMENTS",
            data: res
          });
        }
      )
  }
}
export function deleteProduct(id, fn) {

  return dispatch => {

    fetch(serverUrl + "api/ProductAPI/DeleteProduct", {
      headers: getheader(),
      body: JSON.stringify(id),
      method: "POST"
    }).then(res => res.json())
      .then(res => {
        setErrorDialog(dispatch, res.Message, "حذف کالا");
        if (res.Result) {
          if (fn)
            fn();
        }
      }).catch(e => {
        console.log("[DeleteProduct]", e);
      })
  }
}
export function getAllProductTypes() {
  return dispatch => {
    dispatch({
      type: "GET_PRODUCT_TYPES",
      data: "PENDING"
    });
    fetch(serverUrl + "api/ProductTypeAPI/GetAllProductTypes", {
      headers: getheader(),
      method: "GET",
      cache: "no-cache"
    }).then(res => res.json())
      .then(res => {
        if (res.Message) {
          res = null;
        }
        dispatch({
          type: "GET_PRODUCT_TYPES",
          data: res
        })
      })
  }
}
export function getAllProductTypesNew(onGetData) {
  fetch(serverUrl + "api/ProductTypeAPI/GetAllProductTypes", {
    headers: getheader(),
    method: "GET",
    cache: "no-cache"
  }).then(res => res.json())
    .then(res => {
      if (res.Message) {
        res = null;
      }
      onGetData(res);
    })

}
export function addOrUpdateProductType(data, onAddEdit) {
  postMethodByCallBack(`api/ProductTypeAPI/AddOrUpdateType`, data, onAddEdit, "AddOrUpdateType");
}
export function deleteProductType(id, onDelete) {
  postMethodByCallBack("api/ProductTypeAPI/DeleteProductType", id, onDelete, "DeleteProductType");
}
export function addNewProducts(data, onAdd)
{
  postMethodByCallBack("api/ProductAPI/AddNewProducts",data, onAdd, "AddNewProducts");
}
export function searchHolders(isActive, holderType, onGetData) {
  getMethodByCallBack(`api/GuarantyHolderAPI/SearchHolders?isActive=${isActive ?? ""}&holderType=${holderType ?? ""}`, cacheTypes.NoCache, onGetData, "SearchHolders");
}
export function addEditHolder(data, onAddEdit) {
  postMethodByCallBack("api/GuarantyHolderAPI/AddEditHolder", data, onAddEdit, "AddEditHolder");
}
export function deleteHolder(id, onDelete) {
  postMethodByCallBack("api/GuarantyHolderAPI/DeleteHolder", id, onDelete, "DeleteHolder");
}
export function updateAllProductsPrice(data, onUpdate)
{
  postMethodByCallBack(`api/ProductAPI/UpdateAllProductsPrice`, data, onUpdate,"UpdateAllProductsPrice");
}